import { NextUI } from '@/components/NextUI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslations } from 'next-intl';

interface LanguageOption {
  label: string;
  value: string;
  active?: boolean;
}

const Language = () => {
  const t = useTranslations('modals.language');

  const LANGUAGES: LanguageOption[] = [
    {
      label: t('languages.english'),
      value: 'en',
      active: true,
    },
    {
      label: t('languages.turkish'),
      value: 'tr',
    },
    /*
    {
      label: t('languages.spanish'),
      value: 'es',
    },
    {
      label: t('languages.french'),
      value: 'fr',
    },
    {
      label: t('languages.german'),
      value: 'de',
    },
    {
      label: t('languages.italian'),
      value: 'it',
    },
    */
  ];

  return (
    <NextUI.Modal
      className="max-w-[370px]"
      classNames={{ content: 'py-8 !px-4 md:!px-8 lg:!px-12' }}
      defaultOpen={true}
      name={'Language'}
      backdrop="blur"
      closeButton={
        <FontAwesomeIcon
          icon={['far', 'circle-xmark']}
          className="text-primary-blue"
        />
      }
    >
      <h5 className="text-center font-semibold text-gray-dark">{t('title')}</h5>

      <div className="grid grid-cols-2 mt-6 body-normal">
        {LANGUAGES.map((lang, index) => (
          <NextUI.Button
            variant="link"
            key={index}
            className="p-4 justify-between hover:bg-gray-lightest rounded-[5px]"
            endContent={
              lang.active && (
                <FontAwesomeIcon icon="check" className="text-primary-blue" />
              )
            }
          >
            {lang.label}
          </NextUI.Button>
        ))}
      </div>
    </NextUI.Modal>
  );
};

export default Language;
